import { render, staticRenderFns } from "./Wallpapers.vue?vue&type=template&id=2bac2172&scoped=true&"
import script from "./Wallpapers.vue?vue&type=script&lang=ts&"
export * from "./Wallpapers.vue?vue&type=script&lang=ts&"
import style0 from "./Wallpapers.vue?vue&type=style&index=0&id=2bac2172&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bac2172",
  null
  
)

export default component.exports